import axios from 'axios';
import * as qs from 'qs';
import { ParamsBaseGet } from 'types/common';

export type MaintenanceStatus = 'NORMAL' | 'UPCOMING' | 'DUE' | 'OVERDUE';

export type MaintenanceEngineDevice = {
  id: string;
  assetId: string;
  assetName: string;
  clientName: string | null;
  location: string | null;
  maintenanceStatus: MaintenanceStatus;
  remainingHours: number | null;
  currentReadingValue: number | null;
  iotDeviceId: string | null;
  iotDeviceName: string | null;
  frequencyType: 'INTERVAL' | 'RANGE' | null;
  maintenanceFrequency: number | null;
  minMaintenanceFrequency: number | null;
  maxMaintenanceFrequency: number | null;
  maintenanceTriggerType: string | null;
  sourceCounter: string | null;
  lastMaintenanceDate: string | null;
  calculationType: string | null;
};

export const formatMaintenanceFrequency = (device: MaintenanceEngineDevice) => {
  if (device.frequencyType === 'RANGE') {
    if (device.minMaintenanceFrequency == null && device.maxMaintenanceFrequency == null)
      return '-';
    return `${device.minMaintenanceFrequency ?? '-'} - ${device.maxMaintenanceFrequency ?? '-'}`;
  }
  return device.maintenanceFrequency ?? '-';
};

const SOURCE_COUNTER_LABELS: Record<string, string> = {
  IOT: 'IoT API',
  MANUAL: 'Manually'
};

export const formatSourceCounter = (device: MaintenanceEngineDevice) => {
  if (!device.sourceCounter) return '-';
  return SOURCE_COUNTER_LABELS[device.sourceCounter] ?? device.sourceCounter;
};

export const getMaintenanceEngineDevices = async (
  params: Partial<ParamsBaseGet & { status: MaintenanceStatus }>
) => {
  const query = qs.stringify({ ...params });
  const { data } = await axios.get(`/maintenance-engine?${query}`);
  return data as { success: boolean; total: number; devices: MaintenanceEngineDevice[] };
};
